/**
 * 下载已上传文件。
 *
 * 不宜用全局 axios：main.js 中 axios.defaults.baseURL = '/api'，
 * url 再写 /api/upload/... 时易出现 /api/api/... 拼接错误（表现 404）。
 * 使用 fetch，请求路径固定为「当前站点」/api/upload/download/{id}。
 */
export async function downloadUploadedFile(fileId, fileName) {
  const token = localStorage.getItem('token')
  const headers = {}
  if (token) headers.Authorization = `Bearer ${token}`

  const res = await fetch(`/api/upload/download/${encodeURIComponent(fileId)}`, {
    method: 'GET',
    headers,
    credentials: 'same-origin'
  })

  const blob = await res.blob()

  if (!res.ok) {
    if (res.status === 401) {
      throw new Error('未登录或登录已失效，请重新登录后再试')
    }
    let msg = `下载失败（${res.status}）`
    try {
      const text = await blob.text()
      if (text) {
        try {
          const j = JSON.parse(text)
          msg = j.msg || j.message || msg
        } catch (_e) {
          if (text.length <= 300) msg = text
        }
      }
    } catch (_e) {
      /* noop */
    }
    throw new Error(msg)
  }

  const url = window.URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = fileName || 'download'
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  window.URL.revokeObjectURL(url)
}

export function formatDownloadError(err) {
  return err.message || '下载失败'
}
